@if (showTable) {
  <div #tableContainer class="data-table-container">
    <lib-table-filter-bar
      [startCount]="startCount"
      [endCount]="endCount"
      [totalCount]="totalCount"
      [currentPage]="currentPage"
      [filterName]="filterName"
      [filterColumn]="filterColumn"
    ></lib-table-filter-bar>
    @if (showDateTimePicker) {
      <div
        class="date-time-container data-table-date-time"
        [class.date-picker-from-header]="datePickerFromHeader"
        [ngStyle]="datePickerFromHeader ? { left: menuLeft + 'px', top: menuTop + 'px' } : {}"
        (clickOutside)="closeDateTime($event)"
        >
        <div class="data-table-date-range-control">
          @if (!datePickerFromHeader) {
            <input
              class="data-table-date-range-input"
              [value]="dateRangeDisplayText"
              placeholder="Select Time Range"
              readonly
              (click)="rangePicker.open()"
              />
            <button
              type="button"
              class="data-table-date-range-button"
              aria-label="Select time range"
              (click)="rangePicker.open(); $event.stopPropagation()"
              >
              <i class="pi pi-calendar" aria-hidden="true"></i>
            </button>
          }
          <!-- Keep Material range input in DOM for picker wiring + ngModel updates -->
          <mat-date-range-input class="data-table-date-range-hidden" [rangePicker]="rangePicker">
            <input
              matStartDate
              matInput
              [(ngModel)]="dateRangeStart"
              (dateChange)="onCustomDateRangeStartChanged($event.value)"
              tabindex="-1"
              aria-hidden="true"
              />
            <input
              matEndDate
              matInput
              [(ngModel)]="dateRangeEnd"
              (dateChange)="onCustomDateRangeEndChanged($event.value)"
              tabindex="-1"
              aria-hidden="true"
              />
          </mat-date-range-input>
          <mat-date-range-picker
            #rangePicker
            [calendarHeaderComponent]="rangeHeader"
            panelClass="ziti-date-range-panel"
            [xPosition]="datePickerFromHeader ? 'start' : 'end'"
            [yPosition]="datePickerFromHeader ? 'above' : 'below'"
          ></mat-date-range-picker>
        </div>
      </div>
    }
    @if (gridRendered && showFilterBar) {
      <lib-table-hidden-columns-bar
        [hiddenColumns]="hiddenColumns"
        (columnVisibilityChanged)="columnVisibilityChanged($event)"
      ></lib-table-hidden-columns-bar>
    }
    <div (resize)="resizeGridColumnsDebounced($event)" class="ziti-ag-grid" id="ItemTable">
      <ag-grid-angular
        #nfAgGrid
        [columnDefs]="mergedColumnDefinitions"
        [components]="frameworkComponents"
        [getDataPath]="svc.getDataPath"
        [getRowId]="svc.getRowNodeId"
        [gridOptions]="gridOptions"
        [modules]="gridModules"
        [rowData]="rowData"
        [tooltipHideDelay]="20000"
        [tooltipShowDelay]="0"
        (gridReady)="onGridReady($event)"
        class="ziti-ag-grid-table ag-theme-alpine rows"
        id="ItemGrid"
        >
      </ag-grid-angular>
    </div>
    <div
      [ngClass]="{ open: openHeaderMenu }"
      [ngStyle]="{ left: menuLeft + 'px', top: menuTop + 'px' }"
      class="tMenu action-menu header-menu"
      id="HeaderActionMenu"
      >
      <div (click)="resetTableColumns()" class="tActionRow" id="ResetTableButton">Restore Default Table</div>
      @for (headerAction of headerActions; track headerAction) {
        <div
          (click)="actionRequested.emit({ action: headerAction.action })"
          class="tActionRow"
          id="ResetTableButton"
          >
          {{headerAction.name || headerAction.label}}
        </div>
      }
    </div>
    <div
      [ngClass]="{ open: openMenu }"
      [ngStyle]="{ left: menuLeft + 'px', top: menuTop + 'px' }"
      class="tMenu action-menu item-menu"
      id="RowActionMenu"
      #contextMenu
      >
      @for (menuItem of menuItems; track menuItem) {
        <div
          (click)="actionRequested.emit({ action: menuItem.action, item: selectedItem })"
          [ngClass]="{'menu-item-hidden': hideMenuItem(menuItem, selectedItem) }"
          class="tActionRow"
          id="TableActionButton_{{menuItem.action}}"
          >
          {{menuItem.name || menuItem.label}}
        </div>
      }
    </div>
    <div
      (clickOutside)="closeHeaderFilter($event)"
      [ngClass]="{ open: showFilterOptions }"
      [ngStyle]="{ left: menuLeft + 'px', top: menuTop + 'px' }"
      class="tMenu action-menu header-menu"
      id="HeaderFilterOptions"
      >
      @for (filter of filterOptions; track filter) {
        <div (click)="applyFilter($event, filter)" class="tActionRow" [ngClass]="{'has-icon': filter.icon}" [id]="filter.columnId">
          @if (filter.bubbleClass) {
            <span [ngClass]="filter.bubbleClass" class="bubble">
              @if (filter.showLoader) {
                <svg class="circular" viewBox="25 25 50 50">
                  <circle
                    class="path"
                    cx="50"
                    cy="50"
                    fill="none"
                    r="20"
                    stroke-miterlimit="10"
                    stroke-width="3"
                  ></circle>
                </svg>
              }
            </span>
          }
          @if (filter.icon) {
            <span class="os-icon {{filter.icon}}"></span>
          }
          {{ filter.label }}
        </div>
      }
    </div>
  </div>
} @else {
  <lib-no-items
    (clickEmit)="openCreate()"
    [image]="noItemsImage"
    [isEmpty]="!rowData || rowData.length === 0"
    [typeName]="this.entityTypeLabel"
    [hasAdd]="showNoItemsAdd"
  ></lib-no-items>
}
@if (showTagSelector) {
  <div class="tag-selector-container data-table-tag-selector" [ngStyle]="{ left: menuLeft + 'px', top: menuTop + 'px' }" (clickOutside)="closeTagSelector($event)">
    <div class="buttonBall icon-close" (click)="closeTagSelector($event)"></div>
    <div class="tag-selector-label">
      <span>Select an Attribute:</span>
    </div>
    <lib-tag-selector
      [focusOnInit]="true"
      [availableRoleAttributes]="roleAttributes"
      [availableNamedAttributes]="namedAttributes"
      [(selectedRoleAttributes)]="selectedRoleAttributes"
      [(selectedNamedAttributes)]="selectedNamedAttributes"
      (selectedNamedAttributesChange)="tagSelectionChanged($event, false)"
      (selectedRoleAttributesChange)="tagSelectionChanged($event, true)"
    ></lib-tag-selector>
  </div>
}
